import {
  AssessmentSurveyConfig,
  AssessmentSurveyType,
  DimensionCategoryType,
} from "@/shared/constants/assessmentSurveys";
import { includes, orderBy, startsWith } from "lodash";

export const getIsPersonalityDimension = (group: AssessmentSurveyType) => {
  return includes(
    [AssessmentSurveyType.MAP, AssessmentSurveyType.IPIP_NEO_BIG_5],
    group
  );
};

export const getIsValuesDimension = (group: AssessmentSurveyType) => {
  return includes(
    [AssessmentSurveyType.MATCH_V_V2, AssessmentSurveyType.SHWARTZ_VALUES],
    group
  );
};

export const getIsCompetenciesDimension = (group: AssessmentSurveyType) => {
  return includes(
    [
      AssessmentSurveyType.AP_COMPETENCIES,
      AssessmentSurveyType.WISNIO_COMPETENCIES,
    ],
    group
  );
};

export const getNormalizedDimensionGroup = (group: AssessmentSurveyType) => {
  if (getIsPersonalityDimension(group)) {
    return DimensionCategoryType.PERSONALITY;
  }
  if (getIsValuesDimension(group)) {
    return DimensionCategoryType.VALUES;
  }
  if (getIsCompetenciesDimension(group)) {
    return DimensionCategoryType.COMPETENCIES;
  }

  if (startsWith(group, "opq")) {
    return "opq";
  }

  if (startsWith(group, "hogan")) {
    return "hogan";
  }
  return group;
};

export const getOrderedDimensionConfig = (confg: AssessmentSurveyConfig[]) => {
  return orderBy(confg, (c) => {
    if (getIsPersonalityDimension(c.type)) return 0;
    if (getIsValuesDimension(c.type)) return 1;
    return 2;
  });
};
